import { supabase } from './supabase';
import { sendEmail, emailTemplates } from './email';

// Using types from supabase.ts instead of defining them here

export async function sendPreRaffleReminders() {
  try {
    // Get all active campaigns ending in the next 24 hours
    const now = new Date();
    const tomorrow = new Date(now);
    tomorrow.setDate(tomorrow.getDate() + 1);

    const { data: campaigns, error: campaignsError } = await supabase
      .from('campaigns')
      .select('*')
      .eq('status', 'active')
      .gte('end_date', now.toISOString())
      .lte('end_date', tomorrow.toISOString());

    if (campaignsError) throw campaignsError;

    for (const campaign of campaigns) {
      // Get all paid entries for this campaign
      const { data: entries, error: entriesError } = await supabase
        .from('entries')
        .select('*')
        .eq('campaign_id', campaign.id)
        .eq('payment_status', 'paid');

      if (entriesError) throw entriesError;

      // Send reminder to each entry
      for (const entry of entries) {
        const template = emailTemplates.preRaffleReminder(
          entry.name || 'Participant',
          campaign.name,
          new Date(campaign.end_date).toLocaleDateString()
        );

        await sendEmail({
          to: entry.email,
          ...template
        });
      }
    }
  } catch (error) {
    console.error('Error sending pre-raffle reminders:', error);
    throw error;
  }
}

export async function sendDrawStartNotifications(campaignId: string) {
  try {
    // Get campaign details
    const { data: campaign, error: campaignError } = await supabase
      .from('campaigns')
      .select('*')
      .eq('id', campaignId)
      .single();

    if (campaignError) throw campaignError;

    // Get all paid entries for this campaign
    const { data: entries, error: entriesError } = await supabase
      .from('entries')
      .select('*')
      .eq('campaign_id', campaignId)
      .eq('payment_status', 'paid');

    if (entriesError) throw entriesError;

    // Send notification to each entry
    for (const entry of entries) {
      const template = emailTemplates.drawStarting(
        entry.name || 'Participant',
        campaign.name,
        entry.ticket_number
      );

      await sendEmail({
        to: entry.email,
        ...template
      });
    }
  } catch (error) {
    console.error('Error sending draw start notifications:', error);
    throw error;
  }
}

/**
 * Sends a notification to a winner
 */
export const sendWinnerNotification = async (
  email: string,
  campaignName: string,
  prizeName: string,
  timeLimit: number = 24
) => {
  try {
    const response = await fetch('/api/send-winner-notification', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        email,
        campaignName,
        prizeName,
        timeLimit
      }),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.error || 'Failed to send winner notification');
    }

    return data;
  } catch (error) {
    console.error('Error sending winner notification:', error);
    throw error;
  }
}